import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Color from 'color';
import { SectionTitle } from '../../../shared/sectionable/styles';

const Container = styled(SectionTitle)`
  display: flex;
  flex-direction: column;

  &&& {
    padding-bottom: 0;
  }

  ${props => !props.theme.isXLarge && `
    width: 100%;
  `};

  ${props => props.theme.isMobile && `
    border: none;
    margin: unset;
    padding: unset;
  `};

  & > span {
    text-transform: uppercase;
  }

  & > span:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const logoRatio = 5.625;
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-left: -16px;
  margin-bottom: 32px;
  background-color: ${props => props.bgColor};
  border-radius: 4px;
  border: 0.5px solid #dedfe7;
  box-shadow: 0px 3.98892px 3.98892px rgba(50, 50, 71, 0.04);
  height: 52px;
  width: 100%;
  max-width: 320px;
  ${props => props.theme.isMobile && `
    width: auto;
    max-width: 240px;
    margin-left: -32px;
    margin-right: -32px;
    padding-left: 32px;
    border-radius: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-left: 0px;
  `};


  & > img {
    object-fit: contain;
    max-height: 24px;
    max-width: ${24 * logoRatio}px;
  }
`;

const white = '#ffffff';
export default function Title({ logoPictureUrl, logoColor, name }) {
  let c;
  try {
    c = Color(logoColor || white);
  } catch (err) {
    c = Color(white);
  }

  return (
    <Container>
      {logoPictureUrl && (
        <LogoContainer bgColor={c.rgb().toString()}>
          <img src={logoPictureUrl} alt="logo" />
        </LogoContainer>
      )}
      <span>Investing with</span>
      <span>{name}</span>
    </Container>
  );
}

Title.propTypes = {
  logoPictureUrl: PropTypes.string.isRequired,
  logoColor: PropTypes.string,
  name: PropTypes.string.isRequired,
};

Title.defaultProps = { logoColor: white };
